import { getSortedRowModel as getSortedRowModel_1, getGroupedRowModel as getGroupedRowModel_1, getExpandedRowModel as getExpandedRowModel_1, getPaginationRowModel as getPaginationRowModel_1, getFilteredRowModel as getFilteredRowModel_1, getCoreRowModel as getCoreRowModel_1 } from "@tanstack/table-core";
import { class_type } from "../Docs/fable_modules/fable-library.3.7.1/Reflection.js";
import { nativeColumnDefs } from "./ColumnDef.fs.js";
import { createObj } from "../Docs/fable_modules/fable-library.3.7.1/Util.js";
import { map } from "../Docs/fable_modules/fable-library.3.7.1/Seq.js";

export const getCoreRowModel = getCoreRowModel_1;

const getFilteredRowModel = getFilteredRowModel_1;

const getPaginationRowModel = getPaginationRowModel_1;

const getExpandedRowModel = getExpandedRowModel_1;

const getGroupedRowModel = getGroupedRowModel_1;

const getSortedRowModel = getSortedRowModel_1;

export class TableStateProps$1 {
    constructor() {
    }
}

export function TableStateProps$1$reflection(gen0) {
    return class_type("Feliz.TanStack.Table.TableProps.TableStateProps`1", [gen0], TableStateProps$1);
}

export class tableProps {
    constructor() {
    }
}

export function tableProps$reflection() {
    return class_type("Feliz.TanStack.Table.TableProps.tableProps", void 0, tableProps);
}

export function tableProps_columns_Z2906D979(columns) {
    return ["columns", nativeColumnDefs(columns)];
}

export function tableProps_getSubRows_7C4B0DD6(fn) {
    return ["getSubRows", fn];
}

export function tableProps_onColumnSizingChange_74D9A910(onColumnSizingChange) {
    return ["onColumnSizingChange", onColumnSizingChange];
}

export function tableProps_onColumnSizingInfoChange_Z49BBB024(onColumnSizingInfoChange) {
    return ["onColumnSizingInfoChange", onColumnSizingInfoChange];
}

export function tableProps_onColumnVisibilityChange_ZE40981A(onColumnVisibilityChange) {
    return ["onColumnVisibilityChange", onColumnVisibilityChange];
}

export function tableProps_enableHiding_Z1FBCCD16(hiding) {
    return ["enableHiding", hiding];
}

export function tableProps_sortingFn_Z137B7196(sortingFns) {
    return ["sortingFns", createObj(map((tupledArg) => [tupledArg[0], tupledArg[1]], sortingFns))];
}

export function tableProps_manualSorting_Z1FBCCD16(manualSorting) {
    return ["manualSorting", manualSorting];
}

export function tableProps_onSortingChange_1A8D9596(updater) {
    return ["onSortingChange", updater];
}

export function tableProps_enableSorting_Z1FBCCD16(enableSorting) {
    return ["enableSorting", enableSorting];
}

export function tableProps_enableSortingRemoval_Z1FBCCD16(enableSortingRemoval) {
    return ["enableSortingRemoval", enableSortingRemoval];
}

export function tableProps_enableMultiRemove_Z1FBCCD16(enableMultiRemove) {
    return ["enableMultiRemove", enableMultiRemove];
}

export function tableProps_enableMultiSort_Z1FBCCD16(enableMultiSort) {
    return ["enableMultiSort", enableMultiSort];
}

export function tableProps_sortDescFirst_Z1FBCCD16(sortDescFirst) {
    return ["sortDescFirst", sortDescFirst];
}

export function tableProps_maxMultiSortColCount_Z524259A4(maxMultiSortColCount) {
    return ["maxMultiSortColCount", maxMultiSortColCount];
}

export function tableProps_isMultiSortEvent_Z68196059(isMultiSortEvent) {
    return ["isMultiSortEvent", isMultiSortEvent];
}

export function tableProps_aggregationFns_Z3A9AB39A(aggregationFns) {
    return ["aggregationFns", createObj(map((tupledArg) => [tupledArg[0], tupledArg[1]], aggregationFns))];
}

export function tableProps_manualGrouping_Z1FBCCD16(manualGrouping) {
    return ["manualGrouping", manualGrouping];
}

export function tableProps_onGroupingChange_Z6B4C8463(onGroupingChange) {
    return ["onGroupingChange", onGroupingChange];
}

export function tableProps_onGroupingChange_Z703E96CA(onGroupingChange) {
    return ["onGroupingChange", onGroupingChange];
}

export function tableProps_enableGrouping_Z1FBCCD16(enableGrouping) {
    return ["enableGrouping", enableGrouping];
}

export function tableProps_groupedColumnMode_Z721C83C5(groupedColumnMode) {
    switch (groupedColumnMode) {
        case "reorder":
        case "remove": {
            break;
        }
        default: {
            throw (new Error("Invalid property, must be \u0027reorder\u0027 or \u0027remove\u0027"));
        }
    }
    return ["groupedColumnMode", groupedColumnMode];
}

export function tableProps_manualExpanding_Z1FBCCD16(manualExpanding) {
    return ["manualExpanding", manualExpanding];
}

export function tableProps_onExpandedChange_Z703E96CA(onExpandedChange) {
    return ["onExpandedChange", onExpandedChange];
}

export function tableProps_autoResetExpanded_Z1FBCCD16(autoResetExpanded) {
    return ["autoResetExpanded", autoResetExpanded];
}

export function tableProps_enableExpanding_Z1FBCCD16(enableExpanding) {
    return ["enableExpanding", enableExpanding];
}

export function tableProps_getIsRowExpanded_Z73BEED62(getIsRowExpanded) {
    return ["getIsRowExpanded", getIsRowExpanded];
}

export function tableProps_getRowCanExpand_Z73BEED62(getRowCanExpand) {
    return ["getRowCanExpand", getRowCanExpand];
}

export function tableProps_paginateExpandedRows_Z1FBCCD16(paginateExpandedRows) {
    return ["paginateExpandedRows", paginateExpandedRows];
}

export function tableProps_enableRowSelection_Z1FBCCD16(enableRowSelection) {
    return ["enableRowSelection", enableRowSelection];
}

export function tableProps_enableRowSelection_Z73BEED62(enableRowSelection) {
    return ["enableRowSelection", enableRowSelection];
}

export function tableProps_enableMultiRowSelection_Z1FBCCD16(enableMultiRowSelection) {
    return ["enableMultiRowSelection", enableMultiRowSelection];
}

export function tableProps_enableMultiRowSelection_Z73BEED62(enableMultiRowSelection) {
    return ["enableMultiRowSelection", enableMultiRowSelection];
}

export function tableProps_enableSubRowSelection_Z1FBCCD16(enableSubRowSelection) {
    return ["enableSubRowSelection", enableSubRowSelection];
}

export function tableProps_enableSubRowSelection_Z73BEED62(enableSubRowSelection) {
    return ["enableSubRowSelection", enableSubRowSelection];
}

export function tableProps_onRowSelectionChange_C53F896(onRowSelectionChange) {
    return ["onRowSelectionChange", onRowSelectionChange];
}

export function tableProps_filteredRowModel() {
    return ["getFilteredRowModel", getFilteredRowModel()];
}

export function tableProps_paginationRowModel() {
    return ["getPaginationRowModel", getPaginationRowModel()];
}

export function tableProps_expandedRowModel() {
    return ["getExpandedRowModel", getExpandedRowModel()];
}

export function tableProps_groupedRowModel() {
    return ["getGroupedRowModel", getGroupedRowModel()];
}

export function tableProps_sortedRowModel() {
    return ["getSortedRowModel", getSortedRowModel()];
}

export function tableProps_debugAll() {
    return ["debugAll", true];
}

export function tableProps_debugTable() {
    return ["debugTable", true];
}

//# sourceMappingURL=TableProps.fs.js.map
